import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=4070a5af&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4070a5af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4070a5af')) {
      api.createRecord('4070a5af', component.options)
    } else {
      api.reload('4070a5af', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=4070a5af&scoped=true&", function () {
      api.rerender('4070a5af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28Se2gCaGzT4S/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports